import { useEffect, useState } from 'react';
import { getScopeHeaders } from '../lib/auth-storage';
import { workspaceApi, type Workspace } from '../api/workspaces';

export function WorkspaceSelector({ currentId, onSwitch }: { currentId?: string; onSwitch?: (w: Workspace) => void }) {
  const [items, setItems] = useState<Workspace[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    void (async () => {
      try {
        setItems(await workspaceApi.list({ status: 'active' }));
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load workspaces');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <p className="text-sm text-slate-600">Loading workspaces…</p>;
  if (error) return <p className="text-sm text-red-600">{error}</p>;

  return (
    <label className="block">
      <span className="text-sm font-medium text-slate-700">Workspace</span>
      <select
        value={currentId ?? getScopeHeaders()['X-Workspace-Id'] ?? ''}
        onChange={(e) => void workspaceApi.switch(e.target.value).then(() => {
          const w = items.find((x) => x.id === e.target.value);
          if (w && onSwitch) onSwitch(w);
        })}
        className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm"
        aria-label="Select workspace"
      >
        <option value="" disabled>Select workspace…</option>
        {items.map((w) => (
          <option key={w.id} value={w.id}>{w.name} ({w.slug})</option>
        ))}
      </select>
    </label>
  );
}
